import { createAction } from 'typesafe-actions';
import { ACTIONS, ToastItemType } from './types';

export const addToastAction = createAction(ACTIONS.ADD_TOAST)<ToastItemType>();

export const removeToastAction = createAction(ACTIONS.REMOVE_TOAST)();
